// extracted by mini-css-extract-plugin
export var image = "CourseProgress-module--image--Nd2bd";
export var label = "CourseProgress-module--label---BKMx";
export var name = "CourseProgress-module--name--g9onZ";
export var percentage = "CourseProgress-module--percentage--sQbDj";
export var profile = "CourseProgress-module--profile--Ywjb0";
export var profile_link = "CourseProgress-module--profile_link--uk-jL";
export var progress = "CourseProgress-module--progress--WtRhI";
export var progressComp = "CourseProgress-module--progressComp--Oi0tk";
export var progress_bar = "CourseProgress-module--progress_bar--5FQnG";
export var progress_info = "CourseProgress-module--progress_info--gHRHT";
export var real_progress = "CourseProgress-module--real_progress--Mi-vI";
export var user = "CourseProgress-module--user--q+QR8";
export var userComp = "CourseProgress-module--userComp--hgAeZ";
export var wrapper = "CourseProgress-module--wrapper--AOx+w";